import React, { Component } from "react";

import { CSpinner } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setLayout } from "../../actions/layoutActions";
import { setObj } from "../../actions/noteActions";
import { dashboards, defaultDashboards } from "../../components/Dashboards";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dashboards: []
    };
  }

  componentDidMount() {
    // Essa solução é provisória. Há um outro Card para solucioná-la com uma forma mais eficiente
    if (
      this.props.general.active_roles.role_id === 7 &&
      this.props.general.active_roles.group_id === 62
    ) {
      this.props.history.push("/classroom/me");
    }
    // Esse trecho de código redireciona usuários do tipo aluno que forem do grupo Edu Digital no ambiente de Produção

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let userType = this.props.general.active_roles.role_id;
    let userSegments = this.props.user.user_segments;

    let group = this.props.user;

    if (userType === 7 && userSegments.includes("EI")) {
      this.props.setLayout(false);
    } else {
      this.props.setLayout(true);
    }

    axios
      .get(`${URL.api}general/dashboard/which`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        params: {
          group_id: this.props.general.active_roles.group_id,
          role_id: this.props.general.active_roles.role_id
        }
      })
      .then(
        res => {
          if (res.data.success) {
            this.setState({ loading: false, dashboards: res.data.data });
          } else {
            this.setState({ loading: false });
          }
        },
        () => {
          this.setState({ loading: false });
        }
      );
  }

  calcAge(dateString) {
    if (!dateString) return 20;

    let birthday = new Date(dateString);
    return ~~((Date.now() - birthday) / 31557600000);
  }

  render() {
    let userType = this.props.general.active_roles.role_id;
    let userRoleType = this.props.general.active_roles.type;

    if (this.state.loading) {
      return (
        <div className="flex-1 w-100 h-100 p-5 d-flex align-items-center justify-content-center">
          <CSpinner color="primary" />
        </div>
      );
    }

    const dashboard =
      this.state.dashboards.find(elem => elem.role_id === userType)
        ?.dashboard || defaultDashboards[userRoleType || "A"];

    const json =
      this.state.dashboards.find(elem => elem.role_id === userType)?.json ||
      null;

    const DashboardComponent =
      dashboards.find(elem => elem.name === dashboard)?.component ||
      dashboards[0].component;

    return (
      <DashboardComponent
        history={this.props.history}
        json={
          typeof json === "string" || json instanceof String
            ? JSON.parse(json)
            : json
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
